import React from 'react';

import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { NavButton } from '../../NavButton';
import { Buttons } from '../../styles';

interface SectionProps {
    isAuthenticated?: boolean;
}

export const MainSection = ({ isAuthenticated }: SectionProps) => {
    const primaryYat = useAppSelector((state) => state.user?.primaryYat);
    const location = useLocation();
    const showDiscoverPage = useAppSelector((state) => state.featureFlags.features.showDiscoverPage);

    const profilePath = primaryYat ? `${primaryYat}` : 'profile';

    return (
        <Buttons>
            {showDiscoverPage && (
                <NavButton to="/discover" icon="discover" isActive={location.pathname.startsWith('/discover')}>
                    Discover
                </NavButton>
            )}

            {isAuthenticated && (
                <NavButton
                    to={`/${profilePath}`}
                    icon="profile"
                    isActive={location.pathname.startsWith(`/${encodeURIComponent(profilePath)}`)}
                >
                    Profile
                </NavButton>
            )}
        </Buttons>
    );
};
